import { useQuery } from "@tanstack/react-query";
import { tenantService } from "./services/TenantService";

export const tenantKeys = {
  tenant: (id?: string) => ["tenants", id ?? "unknown"] as const,
};

export function useTenant(id?: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: tenantKeys.tenant(id),
    queryFn: () => tenantService.getTenantById(id as string),
    enabled: !!id && (options?.enabled ?? true),
    staleTime: 5 * 60_000,
    ...options,
  });
}
